<template>
    <v-container fluid fill-height pa-6 class="main-container">
        <v-layout justify-center align-center class="auth-layout">
            <v-flex class="auth-form text-center">
                <div v-html="require('!html-loader!@/assets/images/logo_image.svg')" class="d-inline-flex mb-60" />
                <p class="common-text white-text">Вход в админ-панель</p>
                <div class="main-text mb-4 text-center">
                    Инструкция по восстановлению пароля была отправлена на
                    <span class="yellow-text">
                        sidorov@mail.ru
                    </span>
                </div>
                <div class="main-text mb-4">
                    Если письма нет в папке “Входящие”, <br> проверьте папку “Спам”
                </div>
                <div class="w-100 d-inline-flex flex-column justify-center mt-5">
                    <a href="#" class="auth-link" :class="{'disabled-link': noSend}" @click.prevent="openLogin">
                        Отправить ещё раз
                    </a>
                    <div class="main-text" v-if="noSend">
                        (будет доступно через 60 сек)
                    </div>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    name: 'ConfirmEmail',
    data() {
        return {
            email: null,
            noSend: true,
            error: null,
            errorMessage: null,
        };
    },
    mounted() {
        setTimeout(() => {
            this.noSend = false;
        }, 5000);
    },
    methods: {
        deleteError() {
            this.errorMessage = null;
            this.error = false;
        },
        openLogin() {
            this.$router.push({ name: "login" });
        }
    }
}
</script>

<style scoped>
</style>